import React from "react";
import { Row , Col, Form } from "react-bootstrap";
import Select from 'react-select';
import { deepEqual } from "../../../utils/object";


class SelectEx extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            configuration: { ...props.meta },
            data: props.data ?? props.meta?.default,
            label: props.label,
            locked: Boolean(props.locked)
        }
    }

    getData = () => {
        return this.state.data;
    }

    componentDidUpdate = (oldProps) => {
        if (oldProps.data === this.props.data) return;
        const newData = this.props.data ?? this.props.meta?.default ?? "";
        if (deepEqual(this.state.data, newData)) return;
        // Just sync local state – no callback, no props.onChange here
        this.setState({
            data: newData
        });
    }

    onChange = (e) => {
        if (this.state.data === e.value) return;

        this.setState({
            data: e.value
        }, () => {
            if (this.props.onChange) {
                this.props.onChange();
            }
        });
    }

    render() {
        return (<>
            <Row className="g-3">
                <Col>
                    <div className="mb-3 top-label">
                        <Select
                            id={this.props.element}
                            value={this.state.configuration.items.filter(option => option.value === this.state.data)}
                            className={this.state.configuration?.className}
                            name={this.props.element}
                            onChange={this.state.locked ? null : this.onChange}
                            classNamePrefix="react-select"
                            placeholder=""
                            options={this.state.configuration?.items}
                            disabled={this.state.locked}
                        >
                        </Select><Form.Label>{this.state.label}</Form.Label>
                    </div>
                </Col>
            </Row>
        </>);
    }
};

export default SelectEx;